<template>
  <div class="ui-bottom-loading">
    <p class="item loading" :class="showLoading && !showNoMore ? 'active' : ''">
      <loading-mini></loading-mini>
      <span class="text">{{ loadingText }}</span>
    </p>
    <span class="item no-more-text" :class="showNoMore ? 'active' : ''">
      {{ noMoreText }}
    </span>
  </div>
</template>

<script>
import loadingMini from "@/components/LoadingMini"
export default {
  name: "uiBottomLoading",
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    showNoMore: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: "正在载入..."
    },
    noMoreText: {
      type: String,
      default: "没有更多了"
    }
  },
  components: {
    loadingMini
  }
}
</script>

<style lang="scss" scoped>
.ui-bottom-loading {
  width: 100%;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .item {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    font-family: MicrosoftYaHei;
    font-size: 0.24rem;
    color: #bbbbbb;
    letter-spacing: 0;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &.loading {
      width: 100%;
      height: 100%;
      line-height: 0.6rem;
      text-align: center;
      .text {
        margin-left: 0.18rem;
      }
    }
    &.active {
      opacity: 1;
    }
  }
}
</style>
